module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.ff1e1337.webp";